<mat-toolbar>

  @if (onlyPaper() && onlyPaperHasEmbedding()) {
    <div [matTooltip]="onlyPaper()!.title" class="only-paper-chat-name-wrapper">
      <a routerLink="../chat">
        <mat-icon>arrow_back</mat-icon>
      </a>
      @if (!onlyPaperHasEmbedding()!.hasEmbedding) {
        <span class="no-embedding">  No embeddings found, please start screening </span>
      } @else {
        <span class="only-paper-chat-name-wrapper--name">{{ onlyPaper()!.title }}</span>
      }
    </div>
  } @else {
    @if (isDev() && hasEmbeddingCount() && projectId()) {
      @if (hasEmbeddingCount() === 0) {
        <span class="no-embedding">  No embeddings found, please start screening </span>
      } @else {
        <app-paper-chat-filter
          class="paper-chat-filter"
          [projectId]="projectId()!"
          [changeOnSave]="true">
        </app-paper-chat-filter>
      }
    } @else {
      <span>General chat</span>
    }
  }
  <span class="spacer"></span>

  @if (isDev()) {
    <a mat-flat-button
       routerLink="embedding"
       aria-label="Open Augmentor search"
       tourAnchor="embeddint-result-btn"
    >
      <mat-icon>document_scanner</mat-icon>
      <span>Embedding
        @if (hasEmbeddingCount() && hasEmbeddingTotalCount()) {
          ( {{ hasEmbeddingCount() }} / {{ hasEmbeddingTotalCount() }} papers embedded)
        }
    </span>
    </a>


    <a mat-flat-button
       routerLink="augmentor"
       aria-label="Open Augmentor search"
       tourAnchor="augmenor-search-btn"
    >
      <mat-icon>format_shapes</mat-icon>
      <span>Embedding search</span>
    </a>
  }
</mat-toolbar>
@if (projectId(); as projectId) {
  <app-paper-chat [projectId]="projectId"></app-paper-chat>
}
